import React from 'react'
import CollegeFootball from 'src/components/page/college-football'
import { teamIds } from 'src/constants/personalizationIds'
export default (props) => (
  <CollegeFootball
    {...props}
    team="LSU Tigers"
    subtitle="See the LSU Tigers in action this season"
    teamId={teamIds['LSU Tigers']}
    poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/CFB/LSU.png"
  />
)
